(function() {
    angular
        .module("app")
        .factory("apiService", apiService)

    apiService.$inject = [
        "$rootScope",
        "$http"
    ]

    function apiService(
        $rootScope,
        $http
    ) {
        var service = {}

        service.getDocs = function(customerID, apiConfigID, group, section, format, successCallback, failureCallback) {

            let _group   = ""
            let _section = ""
            let _format  = ""

            if (group !== undefined && group !== null) {

                _group = "?group=" + group

                if (section !== undefined && section !== null) {
                    _section = "&section=" + section
                }

                if (format !== undefined && format !== null) {
                    _format = "&format=" + format
                }

            } else if (section !== undefined && section !== null) {

                _section = "?section=" + section

                if (format !== undefined && format !== null) {
                    _format = "&format=" + format
                }

            } else if (format !== undefined && format !== null) {

                _format = "?format=" + format

            }

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/api_configs/" + apiConfigID + "/documentation" + _group + _section + _format
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.getAPIKeys = function(customerID, apiConfigID, successCallback, failureCallback) {

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/api_configs/" + apiConfigID + "/api_keys"
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.generateAPIKey = function(customerID, apiConfigID, asTest, successCallback, failureCallback) {

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/api_configs/" + apiConfigID + "/api_keys/",
                data: {
                    as_test: asTest
                }
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.deleteAPIKey = function(customerID, apiConfigID, apiKeyID, successCallback, failureCallback) {

            $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/api_configs/" + apiConfigID + "/api_keys/" + apiKeyID
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.getWZDxConfig = function(customerID, wzdxConfigID, successCallback, failureCallback) {

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/wzdx_config/" + wzdxConfigID
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.generateWZDxPassword = function(customerID, wzdxConfigID, successCallback, failureCallback) {

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/wzdx_config/" + wzdxConfigID + "/generate_password"
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.deleteWZDxPassword = function(customerID, wzdxConfigID, successCallback, failureCallback) {

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/wzdx_config/" + wzdxConfigID + "/delete_password"
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        return service
    }
})()
